import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  getPractitionerDefaultSettings,
  profilePostAction,
} from "../../actions/profileAction";

import FormikControl from "../../components/WraapperComponent/FormikControl";
import { getUserDetail } from "../../utils/helper";
const CommissionPopup = ({ commission, closePopup }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const initialValues = {
    percentage: commission ? commission : "",
  };

  const validationSchema = Yup.object({
    percentage: Yup.number()
      .min(1)
      .nullable()
      .required("This field is required"),
  });

  const onSubmit = (values) => {
    var data = {
      percentage: values.percentage,
    };
    var params = {
      params: {
        action: "userAddCommission",
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        dispatch(getPractitionerDefaultSettings());
        closePopup();
      })
    );
  };
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Commission information</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, setFieldValue }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="number"
                        min="1"
                        label="* Percentage"
                        name="percentage"
                        hasError={errors.percentage && touched.percentage}
                      />
                    </div>
                  </div>
                  <div className="submit-section mt-2">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default CommissionPopup;
